import { render, staticRenderFns } from "./InspectionListComponent.vue?vue&type=template&id=864c02b4&"
import script from "./InspectionListComponent.vue?vue&type=script&lang=ts&"
export * from "./InspectionListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionListComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports